module.exports = __webpack_public_path__ + "static/fiore.b40c8a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/fiore.jpg
// module id = 120
// module chunks = 107818501498521 114276838955818